var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('scroll-bar',[_c('el-menu',{attrs:{"mode":"vertical","unique-opened":"","default-active":_vm.$route.meta.active || _vm.$route.path,"collapse":_vm.isCollapse,"background-color":"#363636","text-color":"#fff","active-text-color":"#fff"}},[_c('sidebar-item',{attrs:{"routes":_vm.routes || []}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9a9f797e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/components/Sidebar/index.vue
// module id = n6oz
// module chunks = 83